import { useMemo } from "react"

type MobilePlatform = "ios" | "android" | "other"

export function usePlatform() {
    const platform = useMemo<MobilePlatform>(() => {
        const ua = navigator.userAgent
        if (/iPad|iPhone|iPod/.test(ua)) return "ios"
        if (/Android/.test(ua)) return "android"
        return "other"
    }, [])

    return {
        platform,
        isIOS: platform === "ios",
        isAndroid: platform === "android",
        isMobile: platform === "ios" || platform === "android",
    }
}